import { render, staticRenderFns } from "./falvzhuanjia.vue?vue&type=template&id=a0f24346&scoped=true"
import script from "./falvzhuanjia.vue?vue&type=script&lang=js"
export * from "./falvzhuanjia.vue?vue&type=script&lang=js"
import style0 from "./falvzhuanjia.vue?vue&type=style&index=0&id=a0f24346&prod&scoped=true&lang=less"
import style1 from "./falvzhuanjia.vue?vue&type=style&index=1&id=a0f24346&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f24346",
  null
  
)

export default component.exports